import _styled from "@emotion/styled/base";
import { jsx as _jsx, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { Banner } from '../../components/UpliftAds/components/Banner/index.js';
export const UpliftAds = /*#__PURE__*/_styled(({
  advertisements,
  className = '',
  category = 'hero',
  width,
  height
}) => {
  if (!advertisements || advertisements.length <= 0) {
    return null;
  }
  return _jsx(_Fragment, {
    children: advertisements.map(({
      adId,
      flightId,
      impressionUrl,
      viewableImpressionUrl,
      clickUrl,
      creativeContent
    }) => _jsx(Banner, {
      category: category,
      content: {
        ...creativeContent[0],
        ctPrice: '450'
      },
      impressionUrl: impressionUrl,
      viewableImpressionUrl: viewableImpressionUrl,
      width: width,
      height: height,
      className: `FID_${flightId} ${className}`,
      onClick: () => window.open(clickUrl)
    }, adId))
  });
}, process.env.NODE_ENV === "production" ? {
  target: "e1y35wp30"
} : {
  target: "e1y35wp30",
  label: "UpliftAds"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlVwbGlmdEFkcy5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFRRyIsImZpbGUiOiJVcGxpZnRBZHMuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBqc3ggYXMgX2pzeCwgRnJhZ21lbnQgYXMgX0ZyYWdtZW50IH0gZnJvbSBcIkBlbW90aW9uL3JlYWN0L2pzeC1ydW50aW1lXCI7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBCYW5uZXIgfSBmcm9tICcuLi8uLi9jb21wb25lbnRzL1VwbGlmdEFkcy9jb21wb25lbnRzL0Jhbm5lci9pbmRleC5qcyc7XG5leHBvcnQgY29uc3QgVXBsaWZ0QWRzID0gc3R5bGVkKCh7IGFkdmVydGlzZW1lbnRzLCBjbGFzc05hbWUgPSAnJywgY2F0ZWdvcnkgPSAnaGVybycsIHdpZHRoLCBoZWlnaHQsIH0pID0+IHtcbiAgICBpZiAoIWFkdmVydGlzZW1lbnRzIHx8IGFkdmVydGlzZW1lbnRzLmxlbmd0aCA8PSAwKSB7XG4gICAgICAgIHJldHVybiBudWxsO1xuICAgIH1cbiAgICByZXR1cm4gKF9qc3goX0ZyYWdtZW50LCB7IGNoaWxkcmVuOiBhZHZlcnRpc2VtZW50cy5tYXAoKHsgYWRJZCwgZmxpZ2h0SWQsIGltcHJlc3Npb25VcmwsIHZpZXdhYmxlSW1wcmVzc2lvblVybCwgY2xpY2tVcmwsIGNyZWF0aXZlQ29udGVudCwgfSkgPT4gKF9qc3goQmFubmVyLCB7IGNhdGVnb3J5OiBjYXRlZ29yeSwgY29udGVudDogeyAuLi5jcmVhdGl2ZUNvbnRlbnRbMF0sIGN0UHJpY2U6ICc0NTAnIH0sIGltcHJlc3Npb25Vcmw6IGltcHJlc3Npb25VcmwsIHZpZXdhYmxlSW1wcmVzc2lvblVybDogdmlld2FibGVJbXByZXNzaW9uVXJsLCB3aWR0aDogd2lkdGgsIGhlaWdodDogaGVpZ2h0LCBjbGFzc05hbWU6IGBGSURfJHtmbGlnaHRJZH0gJHtjbGFzc05hbWV9YCwgb25DbGljazogKCkgPT4gd2luZG93Lm9wZW4oY2xpY2tVcmwpIH0sIGFkSWQpKSkgfSkpO1xufSkgYGA7XG4vLyMgc291cmNlTWFwcGluZ1VSTD1VcGxpZnRBZHMuanMubWFwIl19 */");